import React from "react"
import InputMask from "../atoms/InputMask.atom"
import PropTypes from "prop-types"
import ErrorMessageForm from "../atoms/ErrorMessageForm.atom"
import { hasAnyErrors } from "../../utils/validations.utils"
import Label from "../atoms/Label.atom"
import ViewOutputForm from "../atoms/ViewOutputForm.atom"

const InputMaskForm = React.forwardRef((props, ref) => {
  const forId =
    props.id ||
    `input-mask-${props.label?.replace(/ /g, "-")}-${new Date().getTime()}`
  return (
    <>
      <Label htmlFor={forId}>
        {props.label}
        {props.require ? " *" : ""}
        {props.optional ? " (opcional)" : ""}
      </Label>{" "}
      {props.viewOnly ?
        <ViewOutputForm value={props.value} />
      : <InputMask
          ref={ref}
          id={forId}
          name={props.name}
          value={props.value}
          onChange={props.onChange}
          onBlur={(e) => {
            if (props.autoTrim) {
              const trimmedValue = e.target.value.trim()
              e.target.value = trimmedValue
              props.onChange &&
                props.onChange({
                  target: { name: props.name, value: trimmedValue },
                })
            }
            props.onBlur && props.onBlur(e)
          }}
          mask={props.mask}
          placeholder={props.placeholder}
          className={`${hasAnyErrors(props.error) ? "p-invalid" : ""} ${props.className}`}
          disabled={props.disabled}
        />
      }
      {hasAnyErrors(props.error) ?
        <ErrorMessageForm errorMessage={props.error[0]?.errorMessage} />
      : null}
    </>
  )
})

export default InputMaskForm

InputMaskForm.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.string]),
  mask: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  error: PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.array]),
  require: PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.bool]),
  optional: PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.bool]),
  autoTrim: PropTypes.bool,
}

InputMaskForm.defaultProps = {
  autoTrim: true,
}
